import { useEffect } from 'react'
import { toast } from 'sonner'

type Props = {
	message: string
	delayTime: number
}

function random() {
	// return random number between 200 and 2000
	return Math.floor(Math.random() * 700) + 200
}

export function useLandingPopups(props: Props) {
	useEffect(() => {
		let timeout = setTimeout(() => {
			toast.info(props.message.replace('%s', random().toString()), {
				position: 'top-right',
				duration: 40_000,
			})
		}, props.delayTime)

		// every minute, show a toast message from sonner, from the top right corner
		let interval = setInterval(() => {
			toast.info(props.message.replace('%s', random().toString()), {
				position: 'top-right',
				duration: 40_000,
			})
		}, 60_000)

		return () => {
			clearTimeout(timeout)
			clearInterval(interval)
		}
	}, [])
}

export function LandingPopup(props: Props) {
	useLandingPopups(props)
	return null
}
